//简体中文资源
import { AdvancedFunc as ZH_CHS_Advanced } from "./zh-CHS/Advanced-Func";
import { AnalyticalFunc as ZH_CHS_Analytical } from "./zh-CHS/Analytical-Func";
import { DateTimeFunc as ZH_CHS_DateTime } from "./zh-CHS/DateTime-Func";
import { MathFunc as ZH_CHS_Math } from "./zh-CHS/Math-Func";
import { StringFunc as ZH_CHS_String } from "./zh-CHS/String-Func";
import { TranslateFunc as ZH_CHS_Translate } from "./zh-CHS/Translate-Func";
//英文资源
import { AdvancedFunc as EN_Advanced } from "./en/Advanced-Func";
import { AnalyticalFunc as EN_Analytical } from "./en/Analytical-Func";
import { DateTimeFunc as EN_DateTime } from "./en/DateTime-Func";
import { MathFunc as EN_Math } from "./en/Math-Func";
import { StringFunc as EN_String } from "./en/String-Func";
import { TranslateFunc as EN_Translate } from "./en/Translate-Func";
//繁体中文资源
import { AdvancedFunc as ZH_CHT_Advanced } from "./zh-CHT/Advanced-Func";
import { AnalyticalFunc as ZH_CHT_Analytical } from "./zh-CHT/Analytical-Func";
import { DateTimeFunc as ZH_CHT_DateTime } from "./zh-CHT/DateTime-Func";
import { MathFunc as ZH_CHT_Math } from "./zh-CHT/Math-Func";
import { StringFunc as ZH_CHT_String } from "./zh-CHT/String-Func";
import { TranslateFunc as ZH_CHT_Translate } from "./zh-CHT/Translate-Func";

//函数国际化资源包装
export class I18nFunctions {
  private allFunctions: any = new Map();
  constructor() {
    this.allFunctions.clear();
    let zh_chs = [];
    zh_chs = zh_chs.concat(ZH_CHS_Advanced);
    zh_chs = zh_chs.concat(ZH_CHS_Analytical);
    zh_chs = zh_chs.concat(ZH_CHS_DateTime);
    zh_chs = zh_chs.concat(ZH_CHS_Math);
    zh_chs = zh_chs.concat(ZH_CHS_String);
    zh_chs = zh_chs.concat(ZH_CHS_Translate);
    this.allFunctions.set("zh-CHS", zh_chs);

    let en = [];
    en = en.concat(EN_Advanced);
    en = en.concat(EN_Analytical);
    en = en.concat(EN_DateTime);
    en = en.concat(EN_Math);
    en = en.concat(EN_String);
    en = en.concat(EN_Translate);
    this.allFunctions.set("en", en);

    let zh_cht = [];
    zh_cht = zh_cht.concat(ZH_CHT_Advanced);
    zh_cht = zh_cht.concat(ZH_CHT_Analytical);
    zh_cht = zh_cht.concat(ZH_CHT_DateTime);
    zh_cht = zh_cht.concat(ZH_CHT_Math);
    zh_cht = zh_cht.concat(ZH_CHT_String);
    zh_cht = zh_cht.concat(ZH_CHT_Translate);
    this.allFunctions.set("zh-CHT", zh_cht);

  }
  //外部获取
  get(languageCode: string): [] {
    return this.allFunctions.get(languageCode);
  }
}